import {DatePipe} from '@angular/common';
import {Component, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {
    AcabimSite,
    ColumnFilter,
    DataTableColumnData,
    DatatableComponent,
    DataTableConfig,
    DataTablePaginatedDataSource,
    GenericPayloadModel,
    GenericPayloadType, HelpMessage,
    mapPaginatedOrNonPaginatedResponse,
    SiteApiService,
    Status,
    TableAction
} from '@cas-hub/acabim-common-client';
import {MessageService} from 'primeng/api';
import {map} from 'rxjs/operators';

@Component({
    selector: 'acabim-admin-site-list',
    templateUrl: './site-list.component.html',
    styleUrls: ['./site-list.component.scss'],
    providers: [MessageService]

})
export class SiteListComponent extends DataTablePaginatedDataSource<AcabimSite> {

    public readonly columnData: DataTableColumnData[] =
        [
            {displayName: 'Name', objectPropertyName: 'name'},
            {displayName: 'Last Modified', objectPropertyName: 'lastModifiedDate', colWidth: '10rem', textAlign: 'center'},
            // {displayName: 'Group', objectPropertyName: 'group'}

        ];

    public readonly config: DataTableConfig = {
        tableHeading: '',
        isSearchEnabled: true,
        searchPlaceHolder: 'Search for site',
        emptyMessage: '',
        globalFilterFields: [],
        hasCheckbox: true,
        hasDetailsButton: true,
        isLazyLoadingEnabled: true,
        isPaginationEnabled: true,
        hasFilters: true,
        isExportEnabled: false,
        hasActions: true,
        datatableUpdateId: 'Site' // specify Id of object to refresh
    };

    public readonly columnFilters: ColumnFilter[] = [];
    public readonly actions: TableAction[] = [
        {name: 'Archive', id: 0},
        {name: 'Group', id: 1}
    ];

    @ViewChild('dataTable') public dataTable!: DatatableComponent;

    public archivedSiteData: GenericPayloadModel[] = [];
    public archivedSiteDataType = GenericPayloadType;
    public groupName = '';
    public isLoading = false;
    public displayAddModal = false;

    helpMessage: HelpMessage = {
        message: 'Here is a list of sites managed by your organisation. Click on the eye-icon next to the site name ' +
            'to manage its details, see a list of projects and create new ones on the site.<br/><br/>' +
            'A site can be archived if it is no longer managed by your organisation.'
    };

    constructor(
        private readonly messageService: MessageService,
        private readonly siteApiService: SiteApiService,
        protected readonly datePipe: DatePipe,
        public readonly router: Router
    ) {
        super(
            pagination => this.siteApiService.getAllSites(pagination, {
                filterStatus: Status.active,
                includeCoordinates: false,
                includeProjects: false,
                includeGroups: false
            })
                .pipe(
                    map(data => {
                        const convertor = (site: AcabimSite): AcabimSite => {
                            return {
                                ...site,
                                lastModifiedDate: this.datePipe.transform(new Date(site.lastModifiedDate), 'dd MMM yyyy') as string
                            };
                        };
                        return mapPaginatedOrNonPaginatedResponse(data, convertor);
                    })
                )
        );
    }

    public displayArchiveModal = false;
    public archiveCardTitle = 'Archive';
    public displayGroupModal = false;
    public archiveError = false;
    public errorMessage = '';

    setModal(value: boolean): void {
        this.displayArchiveModal = value;
        if (!value) {
            this.archivedSiteData = [];
            this.selectedData = [];
        }
    }

    setGroupModal(value: boolean): void {
        this.displayGroupModal = value;
    }

    setEditModal(value: boolean): void {
        this.showDetails = value;
    }

    getDate(date: string): string {
        const newDate = new Date(date);
        return (this.datePipe.transform(newDate, 'dd MMM yyyy') as string);
    }

    public onSiteArchive(): void {
        if (this.selectedData.length < 1) {
            return;
        }
        this.selectedData.forEach(site => {
            this.archivedSiteData.push({type: this.archivedSiteDataType.text, key: 'site', label: site.name, value: site.id});
            this.displayArchiveModal = true;
        });

    }

    public archiveAction(action: boolean) {
        if (action) {
            this.isLoading = true;
            this.selectedData.forEach((site, index) => {
                this.siteApiService.archiveSite(site.id).subscribe(data => {
                    this.dataTable?.requestImmediateDataRefresh();
                    this.isLoading = false;
                    this.displayArchiveModal = false;
                    this.archivedSiteData = [];
                    this.selectedData = [];
                }, error => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.error.error
                    });
                });
                if (index === this.selectedData.length - 1) {
                    this.isLoading = false;
                    this.displayArchiveModal = false;
                    this.archivedSiteData = [];
                    this.selectedData = [];
                }
            });
        } else {
            this.archivedSiteData = [];
            this.displayArchiveModal = false;
        }
    }

    public onGroupSite() {
        if (this.selectedData.length <= 1) {
            alert('please select at least two sites to group');
        } else {
            this.displayGroupModal = true;
        }
    }

    public groupAction(action: boolean) {
        if (action) {
            const siteIDList: string[] = [];
            this.selectedData.forEach(data => {
                siteIDList.push(data.id);
            });
            console.log(siteIDList);
            this.siteApiService.createSiteGroup(this.groupName, siteIDList).subscribe(data => {
                this.displayGroupModal = false;
            });
        } else {
            this.displayGroupModal = false;

        }
    }

    public onAddSite(): void {
        this.displayAddModal = true;
        // const addSiteRef = this.dialogService.open(AddSiteComponent, {
        //     header: 'Create Site',
        //     baseZIndex: 1090
        // });
        //
        // addSiteRef.onClose.subscribe(site => {
        //     if (site) {
        //         this.dataTable?.requestImmediateDataRefresh();
        //     }
        // });
    }


    Close(message: string) {
        if (message === 'cancel') {
            this.showDetails = false;
        } else if (message === 'update') {
            this.dataTable?.requestImmediateDataRefresh();
        }

    }

    siteGroupAction(value: boolean): void {
        console.dir(value);
        if(value) {
            this.displayGroupModal = false;
            this.selectedData = [];
            this.dataTable?.requestImmediateDataRefresh();
        }
    }

    setAddModal(state: boolean): void {
        // this.displayAddModal = false;
    }

    handleAddModal(state: boolean): void {
        this.displayAddModal = false;
        this.dataTable?.requestImmediateDataRefresh();
    }

    public onAction(action: TableAction): void {
        if (action.id === 0) {
            this.onSiteArchive();
        } else if (action.id === 1) {
            this.onGroupSite();
        }
    }

    public onDataExpanded(value: AcabimSite): void {
    }
}
